import { initialState } from "./state"

export const setAccountFlags = (state, payload) => {
  state.accountFlags = payload
}

export const setDefinitions = (state, payload) => {
  state.definitions = payload
}

export const reset = (state) => {
  state.accountFlags = initialState().accountFlags
}
